import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../components/login.vue'
import Wallet from '../components/wallet.vue'
import Escaperoom from '../components/escaperoom.vue'
import Connect from '../components/connect.vue'


// meta web
import VueMeta from 'vue-meta'


Vue.use(VueMeta)
Vue.use(VueRouter)

const routes = [
  //{path: '/', redirect:'/marketGroup/550000/650000'},
  {path: '/', redirect:'/escaperoom'},
  {path: '/login', component:Login },
  {path: '/escaperoom', component:Escaperoom,
    redirect :'/escaperoom', 
    children : [
      {path: '/wallet', component:Wallet },
      {path: '/escaperoom', component:Escaperoom },
      {path: '/connect', component:Connect },
    ]
  }
  
]
const router = new VueRouter({
  routes
})


export default router